import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { createTask } from 'actions/asyncActions';

import { DATE_FORMATS } from 'constants/dateFormats';
import TaskModal from './TaskModal';

const getInitialValues = ({ date }) => ({
    date: {
        from: date.format(DATE_FORMATS.format),
        to: date.format(DATE_FORMATS.format)
    }
});

@withAsyncActions({
    createTask: createTask
        .withSuccessHandler(props => props.close())
        .withOptions({ autoReset: true })
})
export default class CreateTaskModal extends Component {
    render() {
        const { modal, createTask: { meta }, params, createTask } = this.props;

        return (
            <TaskModal
                initialValues={getInitialValues(params)}
                modal={modal}
                titleTranslate="calendar.create.task_title"
                meta={meta}
                formAction={createTask} />
        );
    }
}
